import { useEffect, useState } from "react";
import { ExternalLink, Link2, Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "../../lib/api";
import { OpportunityForm } from "../../components/admin/OpportunityForm";

const statusLabel = { open: ["متاحة", "badge-green"], full: ["اكتمل الفريق", "badge-muted"], closed: ["مغلقة", "badge-hot"] };

export default function AdminOpportunities() {
  const [items, setItems] = useState(null);
  const [editing, setEditing] = useState(undefined); // undefined=closed, null=new, obj=edit

  const load = () => api.get("/opportunities").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const remove = async (o) => {
    if (!window.confirm(`حذف الفرصة "${o.specialty_ar}"؟`)) return;
    try { await api.delete(`/admin/opportunities/${o.id}`); toast.success("تم حذف الفرصة"); load(); }
    catch (err) { toast.error(errorMessage(err, "تعذر الحذف")); }
  };
  const copy = (o) => { navigator.clipboard?.writeText(`${window.location.origin}/opportunities/${o.id}`); toast.success("تم نسخ رابط الفرصة"); };

  return (
    <div data-testid="admin-opportunities">
      <div className="admin-top"><div><span className="kicker">Opportunities</span><h1>الفرص البحثية</h1></div>
        <button className="btn btn-primary btn-sm" onClick={() => setEditing(null)} data-testid="add-opportunity-button"><Plus size={16} />فرصة جديدة</button></div>
      {items === null ? <div className="page-loader"><span className="loader" /></div> : (
        <div className="table-wrap">
          <table className="tbl"><thead><tr><th>التخصص</th><th>العنوان</th><th>المقاعد</th><th>الموعد</th><th>الحالة</th><th>إجراءات</th></tr></thead>
            <tbody>{items.map((o) => { const [label, cls] = statusLabel[o.status] || [o.status, "badge-muted"]; return (
              <tr key={o.id} data-testid={`admin-opp-row-${o.id}`}>
                <td><b>{o.specialty_ar}</b><br /><small className="muted">{o.specialty_en}</small>{o.featured && <><br /><span className="badge badge-gold" style={{ marginTop: 6 }}>مميزة</span></>}</td>
                <td style={{ fontFamily: "var(--font-en)", fontSize: 12, maxWidth: 360, lineHeight: 1.5 }}>{o.title_en}</td>
                <td><b>{o.remaining_seats}</b> / {o.total_seats}</td>
                <td style={{ fontFamily: "var(--font-en)" }}>{o.deadline || "—"}</td>
                <td><span className={`badge ${cls}`}>{label}</span></td>
                <td><div className="row-actions">
                  <button className="mini-btn" onClick={() => setEditing(o)} data-testid={`edit-opp-${o.id}`}><Pencil size={14} />تعديل</button>
                  <button className="mini-btn" onClick={() => copy(o)} data-testid={`copy-opp-${o.id}`}><Link2 size={14} /></button>
                  <a className="mini-btn" href={`/opportunities/${o.id}`} target="_blank" rel="noreferrer" data-testid={`preview-opp-${o.id}`}><ExternalLink size={14} /></a>
                  <button className="mini-btn danger" onClick={() => remove(o)} data-testid={`delete-opp-${o.id}`}><Trash2 size={14} /></button>
                </div></td>
              </tr>); })}</tbody></table>
        </div>
      )}
      {editing !== undefined && <OpportunityForm initial={editing} onClose={() => setEditing(undefined)} onSaved={() => { setEditing(undefined); load(); }} />}
    </div>
  );
}
